import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { openWhatsApp } from "../../lib/whatsapp";

const links = [
  { href: "#problema", label: "El problema" },
  { href: "#metodo", label: "Método" },
  { href: "#resultados", label: "Resultados" },
  { href: "#aitor", label: "Sobre Aitor" },
  { href: "#servicios", label: "Servicios" },
  { href: "#faq", label: "FAQ" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-40 transition-colors ${
        scrolled
          ? "bg-black/80 backdrop-blur-md border-b border-zinc-900"
          : "bg-transparent"
      }`}
    >
      <div className="w-full max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 flex items-center justify-between h-16">
        <a
          href="#top"
          data-testid="brand-logo"
          className="font-display font-black text-xl uppercase tracking-tight text-white"
        >
          AITOR<span className="text-[#FF5A1F]">.</span>
          <span className="text-zinc-500 font-semibold text-sm ml-2 hidden sm:inline">
            Nutrición & Entrenamiento
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.href.replace("#", "")}`}
              className="text-sm font-semibold uppercase tracking-wider text-zinc-400 hover:text-white transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            data-testid="navbar-cta-whatsapp"
            onClick={() => openWhatsApp("Hola Aitor, quiero CAMBIO")}
            className="hidden sm:inline-flex bg-[#FF5A1F] hover:bg-[#E04814] transition-colors text-white font-bold uppercase tracking-wider text-sm px-5 py-2.5"
          >
            Empezar
          </button>
          <button
            data-testid="navbar-mobile-toggle"
            onClick={() => setOpen((v) => !v)}
            className="lg:hidden text-white p-2"
            aria-label="Abrir menú"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div
          data-testid="navbar-mobile-menu"
          className="lg:hidden bg-black border-t border-zinc-900"
        >
          <div className="flex flex-col px-6 py-4 gap-4">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`nav-mobile-link-${l.href.replace("#", "")}`}
                className="text-zinc-300 hover:text-[#FF5A1F] uppercase tracking-wider font-semibold text-sm"
              >
                {l.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
};
